import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorSetupModalService {
  private _isOpen = false;
  private _message = 'security.guard.modal.message';

  get isOpen(): boolean {
    return this._isOpen;
  }

  get message(): string {
    return this._message;
  }

  open(message?: string): void {
    if (message?.trim()) {
      this._message = message.trim();
    }
    this._isOpen = true;
  }

  close(): void {
    this._isOpen = false;
  }
}
